import { getNestedProperty, getFrontImage } from '@grandvisionhq/utils';

function getProductImageUrl(suggestion) {
    const images = getNestedProperty(suggestion, 'masterVariant.media.images', []);
    const imageUrl = getFrontImage(images).url;
    return `${imageUrl}?w=75&auto=format`;
}

export { getProductImageUrl };
//# sourceMappingURL=getProductImageUrl.js.map
